// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const fetchOrderExplanation = createAction(
	'model/orderExplainer/fetch',
	function prepare(payload: { orderDetailId: number | string }) {
		return {
			payload,
		};
	}
);

